import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export interface FormState {
  isLoading: boolean;
  isSubmitted: boolean;
  error: string | null;
  success: string | null;
}

@Injectable({
  providedIn: 'root'
})
export class FormStateService {
  private formStateSubject = new BehaviorSubject<FormState>({
    isLoading: false,
    isSubmitted: false,
    error: null,
    success: null
  });

  public formState$: Observable<FormState> = this.formStateSubject.asObservable();

  setLoading(loading: boolean): void {
    this.updateState({ isLoading: loading });
  }

  setSuccess(message: string): void {
    this.updateState({ 
      success: message, 
      error: null, 
      isLoading: false,
      isSubmitted: true 
    });
  }

  setError(error: string): void {
    this.updateState({ 
      error, 
      success: null, 
      isLoading: false,
      isSubmitted: false 
    });
  }

  clearState(): void {
    this.updateState({
      isLoading: false,
      isSubmitted: false,
      error: null,
      success: null
    });
  }

  private updateState(partialState: Partial<FormState>): void {
    const currentState = this.formStateSubject.value;
    this.formStateSubject.next({ ...currentState, ...partialState });
  }
}